<app-crm-synchronization-conversation-frequency
  [crmType]="crmType"
  [conversationSyncFrequencies]="conversationSyncFrequencies">
</app-crm-synchronization-conversation-frequency>

<app-crm-synchronization-conversation-agent-workflow
  [crmType]="crmType"
  [triggerMsgRepliedByAgentAndUserMatched]="triggerMsgRepliedByAgentAndUserMatched"
  [triggerMsgRoutedToCrmTeam]="triggerMsgRoutedToCrmTeam"
  [configuration]="configuration"
  (agentWorkflowChanged)="agentWorkflowChanged.emit($event)"
  (zendeskContinuousSynchronizationChanged)="zendeskContinuousSynchronizationChanged.emit($event)">
</app-crm-synchronization-conversation-agent-workflow>

<app-crm-synchronization-conversation-workflow-mappings
  *ngIf="crmType === 'salesforce'"
  [organizationId]="organizationId"
  [configuration]="configuration"
  [freshData]="freshData"
  (workflowMappingFromAlcmeonToSalesforceChanged)="workflowMappingFromAlcmeonToSalesforceChanged.emit($event)"
  (workflowMappingFromSalesforceToAlcmeonChanged)="workflowMappingFromSalesforceToAlcmeonChanged.emit($event)">
</app-crm-synchronization-conversation-workflow-mappings>
